import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import { Icon } from "@mui/material";
import CTAButton from "../buttons/CTAButton";
import NavbarDrawer from "./NavbarDrawer";
import { SECTIONS } from "../../constants/placeholder";
import Logo from "../../assets/images/logo_blue_transparent.png";
import LoadingBackdrop from "../feedbacks/LoadingBackdrop";
import { FaPhone } from "react-icons/fa6";
import { IoMail } from "react-icons/io5";
import { IoLocation } from "react-icons/io5";
import {
  FaXTwitter,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa6";

import { COMPANY_DATA } from "../../constants/placeholder";

function Navbar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = (to) => {
    setAnchorElNav(null);
    window.scrollTo({ top: 0, behavior: "smooth" });
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate(to);
    }, 1000);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar
      position="absolute"
      sx={{ zIndex: 99 }}
      color="transparent"
      elevation={0}
    >
      <Container>
        <div className="flex justify-between align-middle items-center text-gray-300 text-xs my-3 md:my-6 border-b-[1px] py-1 border-b-gray-600">
          <div className="contact flex gap-4 justify-between align-middle items-center">
            <div className="flex justify-start gap-1 align-middle items-center">
              <FaPhone />
              <p>{COMPANY_DATA.phones[0]}</p>
            </div>
            <div className="flex justify-start gap-1 align-middle items-center">
              <IoMail />
              <p>{COMPANY_DATA.emails[0]}</p>
            </div>
            {/* <div className="hidden md:flex justify-start gap-1 align-middle items-center">
              <IoLocation />
              <p>{COMPANY_DATA.addresses[0].name}</p>
            </div> */}
          </div>
          <div className="hidden text-lg socials md:flex justify-end gap-4 align-middle items-center ">
            <Link
              to={"https://www.facebook.com/share/15qgVDxuFV/?mibextid=wwXIfr"}
            >
              {" "}
              <FaFacebookF />{" "}
            </Link>
            <Link
              to={
                "https://www.instagram.com/_renphaconsulting?igsh=cGI3dzNic2ZtbGxp"
              }
            >
              {" "}
              <FaInstagram />{" "}
            </Link>
            <FaLinkedinIn />
          </div>
        </div>
        <Toolbar disableGutters sx={{ alignItems: "center" }}>
          <Box variant="h4" noWrap component="a" href="/">
            <img
              src={Logo}
              alt="Renpha logo"
              loading="lazy"
              className="h-12 md:h-20"
            />
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "flex", md: "none" },
              justifyContent: "center",
              alignItems: "end",
              mr: "auto",
            }}
          >
            {/* <CTAButton
              text="Get in touch"
              fullWidth={false}
              bgcolor="primary.main"
              size="small"
              my={0}
            /> */}

            <a
              target="_blank"
              href="https://wa.me/message/VIGHOLT7SHWFJ1"
              class="px-6 py-2  font-medium text-white bg-primary rounded-full shadow-2xl hover:bg-primary-dark"
            >
              Get in Touch
            </a>
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: "flex-end",
              alignItems: "center",
              gap: 8,
            }}
          >
            <Box
              disableGutters
              sx={{ display: { xs: "none", md: "flex" }, alignIetms: "end" }}
            >
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                {SECTIONS.map((page, index) => (
                  <Box key={index} display="flex" alignItems="center">
                    <a href={page.to}>
                      <Typography
                        variant="body2"
                        color="white"
                        // color={
                        //   window.location.href.includes(page.to)
                        //     ? "primary"
                        //     : "white"
                        // }
                        fontWeight={500}
                      >
                        {page.text}
                      </Typography>
                    </a>
                  </Box>
                ))}
              </Box>
            </Box>
            {/* <CTAButton
              text="Get in Touch"
              fullWidth={false}
              bgcolor="primary.main"
              my={0}
            /> */}
            <a
              target="_blank"
              href="https://wa.me/message/VIGHOLT7SHWFJ1"
              class="px-6 py-2  font-medium text-white bg-primary rounded-full shadow-2xl hover:bg-primary-dark"
            >
              Get in Touch
            </a>
          </Box>
          <NavbarDrawer
            drawerOpen={drawerOpen}
            setDrawerOpen={setDrawerOpen}
            pages={SECTIONS}
            handleCloseNavMenu={handleCloseNavMenu}
          />
        </Toolbar>

        <LoadingBackdrop open={loading} />
      </Container>
    </AppBar>
  );
}
export default Navbar;
